// import { CandidateCount } from "../../../../../../models/candidateCount";
// import { Resume } from '../../../../../../models/resume';
import { JobMatchAction } from '../../../../../../models/jobMatchAction';
var UploadResumesProcessedCandidatesController = /** @class */ (function () {
    /*@ngInject*/
    function UploadResumesProcessedCandidatesController($scope, $rootScope, $timeout, $uibModal, $filter, modalService, jobMatchActionsService, alertsAndNotificationsService, resumeService, jobMatchService, candidateService, jobService, notificationsService, MESSAGECONSTANTS) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.modalService = modalService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.resumeService = resumeService;
        this.jobMatchService = jobMatchService;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.notificationsService = notificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    UploadResumesProcessedCandidatesController.prototype.$onInit = function () {
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.gettingCountsFlag = false;
        if (!this.candidatesCount) {
            this.candidatesCount = {};
        }
        else {
            // Check For Duplicate Id's
            this._checkDuplicatesCandidatesExists();
        }
        this.initVariables();
        if (this.candidateId !== "") {
            this.isSingleCandidateUpload = true;
        }
        //initialize the variables
        if (!_.isNull(this.jobId) && this.jobId != '') {
            this.jobContextExistsFlag = true;
            this.createJobMatchesObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                manuallyMatchedFromUI: true,
                transactionId: null,
                isAssociateCandidate: false,
                overrideNoteDetails: []
            };
        }
        this.resumeList = [];
        this.candidatesList = this.candidatesCount.candidates;
        this._setDetails();
        this._checkIfOutreachEnabled();
        this.candidatesCount.createdCount = this.candidatesCount.create ? this.candidatesCount.create.matchedCandidateCount + this.candidatesCount.create.unMatchedCandidateCount : 0;
        this.candidatesCount.updatedCount = this.candidatesCount.update ? this.candidatesCount.update.matchedCandidateCount + this.candidatesCount.update.unMatchedCandidateCount : 0;
    };
    UploadResumesProcessedCandidatesController.prototype.initVariables = function () {
        this.resumeList = [];
        this.uploadResumesResponse = null;
        this.totalUploads = null;
        // this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.candidateCount = null;
        this.createJobMatchesObject = null;
        this.ResumeProcessedCandidatesList = [];
        // flags
        this.showCandidateUpdateFailureMessage = false;
        this.isSingleCandidateUpload = false;
        this.fileExistsFlag = false;
        this.fileUploadInProgressFlag = false;
        this.mandatoryFieldsError = false;
        this.disableSourceTypesFlag = false;
        this.resumeScoringDoneFlag = false;
        this.scoringCandidatesFlag = false;
        this.gettingCountsFlag = false;
        this.jobContextExistsFlag = false;
        this.associatingCandidatesFlag = false;
        this.selectedAllCandidatesFlag = false;
        this.displaySelectDeselectButtonFlag = true;
        this.additionalMatchRuleVerifiedCopy = false;
        this.additionalMatchRuleVerificationPassedCopy = false;
        this.isDirectCandidateUpdate = true;
        this.sendOutreachEmailMultipleResume = false;
        this.sendOutreachEmailJobContext = false;
        this.sendOutreachEmailSingleResume = false;
        this.completeResumeSavingFlag = false;
        this.completeSendOutreachAssociatingCandidatesFlag = false;
        this.isAssociateCandidatesExits = false;
    };
    UploadResumesProcessedCandidatesController.prototype._checkDuplicatesCandidatesExists = function () {
        if (this.candidatesCount.matchedCandidateIdAndNames) {
            this.candidatesCount.matchedCandidateIdAndNames = _.unique(this.candidatesCount.matchedCandidateIdAndNames, 'candidateId');
        }
        if (this.candidatesCount.unMatchedCandidateIdAndNames) {
            this.candidatesCount.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.unMatchedCandidateIdAndNames, 'candidateId');
        }
        if (this.candidatesCount.update) {
            if (this.candidatesCount.update.matchedCandidateIdAndNames) {
                this.candidatesCount.update.matchedCandidateIdAndNames = _.unique(this.candidatesCount.update.matchedCandidateIdAndNames, 'candidateId');
            }
            if (this.candidatesCount.update.unMatchedCandidateIdAndNames) {
                this.candidatesCount.update.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.update.unMatchedCandidateIdAndNames, 'candidateId');
            }
        }
        if (this.candidatesCount.create) {
            if (this.candidatesCount.create.matchedCandidateIdAndNames) {
                this.candidatesCount.create.matchedCandidateIdAndNames = _.unique(this.candidatesCount.create.matchedCandidateIdAndNames, 'candidateId');
            }
            if (this.candidatesCount.create.unMatchedCandidateIdAndNames) {
                this.candidatesCount.create.unMatchedCandidateIdAndNames = _.unique(this.candidatesCount.create.unMatchedCandidateIdAndNames, 'candidateId');
            }
        }
    };
    UploadResumesProcessedCandidatesController.prototype._setDetails = function () {
        var _this = this;
        var jobId = null;
        if (this.jobId !== '' && this.jobId !== undefined && this.jobId !== null) {
            jobId = this.jobId;
        }
        this._massageCandidateDetails();
        this._getCandidateCounts();
        this.getAllActivityTypes();
        var associateCandidatesList = [];
        this.candidatesList.map(function (candidate) {
            if (candidate.candidateId) {
                _this.ResumeProcessedCandidatesList.push(candidate.candidateId);
            }
            if (!candidate.candidateMatchedToJob) {
                associateCandidatesList.push(candidate.candidateId);
            }
        });
        this.isAssociateCandidatesExits = associateCandidatesList.length > 0 ? true : false;
    };
    UploadResumesProcessedCandidatesController.prototype._massageCandidateDetails = function () {
        var _this = this;
        angular.forEach(this.candidatesList, function (val, key) {
            if (_.isNull(val.firstName)) {
                val.firstName = "-";
            }
            if (_.isNull(val.lastName)) {
                val.lastName = "-";
            }
            if (_.isNull(val.email)) {
                val.email = "-";
            }
            if (_.isNull(val.phone)) {
                val.phone = "-";
            }
            val.name = val.firstName + ' ' + val.lastName;
            if (val.mobilePhoneCountryCodePresent) {
                var phoneNumberObject = libphonenumber.parse(val.phone.toString());
                if (phoneNumberObject.phone !== undefined) {
                    val.phone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
                }
            }
            // floor the match score to the lower integer value.
            val.score = Math.floor(parseFloat(val.score));
            val.selectedFlag = false;
            if (val.score >= val.jobThresholdScore) {
                val.intelligenceScorePassFlag = true;
            }
            var candidateMatchedToJob = false;
            // Newly created candidate
            if (val.newCandidate && _this.candidatesCount.create) {
                candidateMatchedToJob = !_this.candidatesCount.create.unMatchedCandidateIdAndNames
                    .map(function (can) { return can.candidateId; })
                    .includes(val.candidateId);
            }
            // Updated candidate
            if (!val.newCandidate && _this.candidatesCount.update) {
                candidateMatchedToJob = !_this.candidatesCount.update.unMatchedCandidateIdAndNames
                    .map(function (can) { return can.candidateId; })
                    .includes(val.candidateId);
            }
            val.candidateMatchedToJob = candidateMatchedToJob;
            if (val.candidateMatchedToJob) {
                val.allowManualMatch = false;
            }
        });
    };
    UploadResumesProcessedCandidatesController.prototype._checkIfOutreachEnabled = function () {
        // this.candidateService.getOutreachEmailEnabledStatus((data) => {
        //     this.isOutreachEnabled = data;
        // }, (error) => {
        //     this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        // });
        this.isOutreachEnabled = true;
    };
    UploadResumesProcessedCandidatesController.prototype.getAllActivityTypes = function () {
        var _this = this;
        this.activityMap = [];
        this.jobService.getActivityTypes(function (data) {
            angular.forEach(data, function (val, key) {
                _this.activityMap[val.value] = val.name;
            });
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadResumesProcessedCandidatesController.prototype.runResumeScoringForAssociate = function (contactDetails) {
        var _this = this;
        var isUpdate = false;
        if (contactDetails) {
            isUpdate = true;
            this.uploadResumesResponse.candidateContactDetail = contactDetails;
        }
        this.uploadResumesResponse.file = this.uploadResumesResponse.files[0];
        this.resumeService.runResumeScoringForAssociate(this.uploadResumesResponse, this.candidateId, this.jobId, isUpdate, function (data) {
            _this.candidateDetailsToUpdate = data;
            if (!isUpdate) {
                _this.additionalMatchRuleVerifiedCopy = _this.candidateDetailsToUpdate.additionalMatchRuleVerified;
                _this.additionalMatchRuleVerificationPassedCopy = _this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed;
            }
            var fetchNewCandidateDetails = {
                firstName: _this.candidateDetailsToUpdate.candidateConflictDetails[0].newValue,
                lastName: _this.candidateDetailsToUpdate.candidateConflictDetails[1].newValue,
                email: _this.candidateDetailsToUpdate.candidateConflictDetails[2].newValue,
                phoneNumber: _this.candidateDetailsToUpdate.candidateConflictDetails[3].newValue
            };
            _this.fetchOldCandidateDetails = {
                firstName: _this.candidateDetailsToUpdate.candidateConflictDetails[0].oldValue,
                lastName: _this.candidateDetailsToUpdate.candidateConflictDetails[1].oldValue,
                email: _this.candidateDetailsToUpdate.candidateConflictDetails[2].oldValue,
                phoneNumber: _this.candidateDetailsToUpdate.candidateConflictDetails[3].oldValue
            };
            if (_this.candidateDetailsToUpdate.candidateUpdated) {
                if (!isUpdate) {
                    _this.isDirectCandidateUpdate = true;
                }
                _this.scoringCandidatesFlag = false;
                _this.resumeScoringDoneFlag = true;
                _this.candidatesList.push(fetchNewCandidateDetails);
            }
            else if (_this.candidateDetailsToUpdate.candidateConflicts) {
                _this.isDirectCandidateUpdate = false;
                _this.showCandidateUpdateFailureMessage = true;
                _this.scoringCandidatesFlag = false;
                _this.resumeScoringDoneFlag = true;
                if (isUpdate) {
                    _this.candidateDetailsToUpdate.additionalMatchRuleVerified = _this.additionalMatchRuleVerifiedCopy;
                    _this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed = _this.additionalMatchRuleVerificationPassedCopy;
                }
            }
            else {
                _this.isDirectCandidateUpdate = false;
                _this._showConflictsModal(_this.candidateDetailsToUpdate);
            }
            // else {
            //     let message = "";
            //     if(this.candidateDetailsToUpdate.additionalMatchRuleVerified && this.candidateDetailsToUpdate.additionalMatchRuleVerificationPassed) {
            //         message = "Additional matching criteria of education and experience have been verified. <br>";
            //     }
            //     message = message + "The candidate details will be updated with that in the Resume. <br> Do you really want to update the Candidate Information with the details in the Resume?";
            //     bootbox.confirm({
            //         closeButton: false,
            //         title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirmation to Update Candidate!</strong></div>",
            //         message: message,
            //         className: "zIndex1060",
            //         backdrop: true,
            //         onEscape: false,
            //         buttons: {
            //             confirm: {
            //                 label: 'Yes',
            //                 className: 'btn-info'
            //             },
            //             cancel: {
            //                 label: 'Cancel',
            //                 className: 'btn-danger'
            //             }
            //         }, callback: (result) =>  {
            //             if(result) {
            //                 this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            //                 this.runResumeScoringForAssociate(fetchNewCandidateDetails);
            //             } else {
            //                 this.candidatesList = [];
            //                 this.candidatesList.push(this.fetchOldCandidateDetails);
            //                 this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            //                 this.scoringCandidatesFlag = false;
            //                 this.resumeScoringDoneFlag = true;
            //                 this.disableNextButtonFlag = false;
            //                 this.disablePreviousButtonFlag = false;
            //             }
            //         }
            //     });
            // }
            if (_this.candidateProcessedCallback) {
                _this.candidateProcessedCallback();
            }
        }, function (error) {
        });
    };
    UploadResumesProcessedCandidatesController.prototype._showConflictsModal = function (candidateConflictDetails) {
        var _this = this;
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(function () {
            var conflictModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowClass: 'four-dot-five-modal-medium',
                component: 'compareAndUpdateCandidateDetailsModal',
                resolve: {
                    candidateConflictDetails: function () {
                        return candidateConflictDetails;
                    }
                }
            });
            conflictModal.result.then(function (callbackObject) {
                if (callbackObject.callbackType == 'save') {
                    _this.runResumeScoringForAssociate(callbackObject.entity);
                }
                else {
                    _this.scoringCandidatesFlag = false;
                    _this.resumeScoringDoneFlag = true;
                    _this.candidatesList = [];
                    _this.candidatesList.push(_this.fetchOldCandidateDetails);
                }
            }, function (dismiss) {
                //do nothing
            });
        }, 300);
    };
    UploadResumesProcessedCandidatesController.prototype.candidateToAssociateToggle = function (candidate) {
        // if it is selected, add to associate list
        if (candidate.selectedFlag) {
            this.candidatesToAssociateList.push(candidate);
        }
        else {
            // if selected is removed, remove from candidates to associate list
            _.remove(this.candidatesToAssociateList, {
                candidateId: candidate.candidateId
            });
            _.remove(this.createJobMatchesObject.overrideNoteDetails, {
                candidateId: candidate.candidateId
            });
        }
    };
    UploadResumesProcessedCandidatesController.prototype.associateCandidates = function (successCallback) {
        var _this = this;
        angular.forEach(this.candidatesToAssociateList, function (val, key) {
            _this.createJobMatchesObject.candidateIds.push(val.candidateId);
        });
        this.associatingCandidatesFlag = true;
        var associatingDialog = bootbox.dialog({
            message: '<p class="text-center">Adding Candidates <i class="fa fa-spinner fa-spin"></i></p>',
            closeButton: false
        });
        this.createJobMatchesObject.isAddCandidate = true;
        this.jobMatchService.createJobMatches(this.createJobMatchesObject, function (data) {
            _this.associatingCandidatesFlag = false;
            associatingDialog.modal('hide');
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            angular.forEach(_this.candidatesToAssociateList, function (val, key) {
                // find each associated candidate in the original candidates list
                var index = _.findIndex(_this.candidatesList, {
                    candidateId: val.candidateId
                });
                // for each candidate, set the added successfully flag to true and selected flag to false
                _this.candidatesList[index].candidateMatchedToJob = true;
                _this.candidatesList[index].statusOfJobMatch = 'Candidate Added.';
                _this.candidatesList[index].selectedFlag = false;
                _this.candidatesList[index].jobMatchManuallyCreated = (_this.candidatesList[index].score < _this.candidatesList[index].jobThresholdScore);
                //update notification payload
                if (_this.candidatesCount.update) {
                    if (_this.candidatesCount.update.unMatchedCandidateIdAndNames && _this.candidatesCount.update.unMatchedCandidateIdAndNames.length > 0) {
                        _this.candidatesCount.update.unMatchedCandidateIdAndNames.forEach(function (candidate) {
                            if (candidate.candidateId == val.candidateId) {
                                _this.candidatesCount.update.unMatchedCandidateCount--;
                                _this.candidatesCount.update.matchedCandidateCount++;
                                _this.candidatesCount.update.matchedCandidateIdAndNames.push(Object.assign({}, candidate, { jobMatchManuallyCreated: _this.candidatesList[index].jobMatchManuallyCreated }));
                                _.remove(_this.candidatesCount.update.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
                if (_this.candidatesCount.create) {
                    if (_this.candidatesCount.create.unMatchedCandidateIdAndNames && _this.candidatesCount.create.unMatchedCandidateIdAndNames.length > 0) {
                        _this.candidatesCount.create.unMatchedCandidateIdAndNames.forEach(function (candidate) {
                            if (candidate.candidateId == val.candidateId) {
                                _this.candidatesCount.create.unMatchedCandidateCount--;
                                _this.candidatesCount.create.matchedCandidateCount++;
                                _this.candidatesCount.create.matchedCandidateIdAndNames.push(Object.assign({}, candidate, { jobMatchManuallyCreated: _this.candidatesList[index].jobMatchManuallyCreated }));
                                _.remove(_this.candidatesCount.create.unMatchedCandidateIdAndNames, {
                                    candidateId: val.candidateId
                                });
                            }
                        });
                    }
                }
            });
            _this.candidatesCount.candidates = JSON.parse(angular.toJson(_this.candidatesList));
            //Send outreach
            if (_this.sendOutreachEmailJobContext && _this.isOutreachEnabled) {
                var candidateIds_1 = [];
                _this.candidatesList.map(function (candidate) {
                    if (candidate.candidateMatchedToJob) {
                        candidateIds_1.push(candidate.candidateId);
                    }
                });
                if (candidateIds_1.length > 0) {
                    _this._sendCandidateOutReachEmail(candidateIds_1, function () { });
                }
            }
            // make the candidates to associate list as empty.
            _this.candidatesToAssociateList = [];
            // get the candidate counts again as manually matched counts might have changed.
            _this._getCandidateCounts();
            if (successCallback) {
                successCallback();
            }
            else {
                _this.alertsAndNotificationsService.showBannerMessage("Candidates have be successfully added to the job", "success");
                _this.$rootScope.$broadcast('refreshJobWorkflow', null);
                //save api
                if (_this.notificationId) {
                    _this.notificationsService.saveCandidateResumeNotification(_this.notificationId, _this.candidatesCount, function (data) {
                        if (_this.completeCallback) {
                            _this.completeCallback();
                        }
                    }, function (error) {
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else {
                    if (_this.completeCallback) {
                        _this.completeCallback();
                    }
                }
            }
        }, function (error) {
            _this.associatingCandidatesFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadResumesProcessedCandidatesController.prototype._getCandidateCounts = function () {
        this.displaySelectDeselectButtonFlag = (this.candidatesCount.create && this.candidatesCount.create.unMatchedCandidateCount !== 0) || (this.candidatesCount.update && this.candidatesCount.update.unMatchedCandidateCount !== 0);
    };
    UploadResumesProcessedCandidatesController.prototype.showOverrideCandidateSuspensionModal = function (candidate) {
        var _this = this;
        var candidateId = candidate.candidateId;
        var candidateName = candidate.name;
        var suspendedMonths = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.numberOfMonthsToWait : candidate.jobLeftCandidateDetailDTO.numberOfMonthsToWait;
        var releaseDate = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO.releasedAt : candidate.jobLeftCandidateDetailDTO.leftAt;
        var allowOverride = candidate.allowOverride;
        var releasedJobDetails = candidate.overrideFor === "RELEASE" ? candidate.releasedCandidateDetailDTO : candidate.jobLeftCandidateDetailDTO;
        var type = candidate.overrideFor === "RELEASE" ? "release" : "jobLeft";
        if (allowOverride) {
            $(".modal").addClass("upload-resumes-modal-medium");
            this.$timeout(function () {
                var warningModal = _this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowClass: 'four-dot-five-modal-medium',
                    component: 'uploadResumesActionsModal',
                    resolve: {
                        candidateId: function () {
                            return candidateId;
                        },
                        candidateName: function () {
                            return candidateName;
                        },
                        suspendedMonths: function () {
                            return suspendedMonths;
                        },
                        releaseDate: function () {
                            return releaseDate;
                        },
                        allowOverride: function () {
                            return allowOverride;
                        },
                        releasedJobDetails: function () {
                            return releasedJobDetails;
                        },
                        type: function () {
                            return type;
                        }
                    }
                });
                warningModal.result.then(function (callbackObject) {
                    if (callbackObject.callbackType == 'save') {
                        var index = _.findIndex(_this.candidatesList, {
                            candidateId: candidate.candidateId
                        });
                        _this.createJobMatchesObject.overrideNoteDetails.push(callbackObject.entity);
                        _this.candidatesList[index].allowManualMatch = true;
                        _this.candidatesList[index].showOverride = false;
                        _this.candidatesList[index].statusOfJobMatch = 'Candidate is made available for matching.';
                        _this.candidatesList[index].selectedFlag = true;
                        _this.candidateToAssociateToggle(_this.candidatesList[index]);
                    }
                }, function (dismiss) {
                    //do nothing
                });
            }, 300);
        }
        else {
            var displayHtmlText = "";
            if (type == 'release') {
                displayHtmlText = "Candidate '<span class='emerald'>" + candidateName + "</span>' cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of candidate's previous release. ";
                displayHtmlText = displayHtmlText + "Candidate was previously released on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            else {
                displayHtmlText = "Candidate <span class='emerald'>'" + candidateName + "'</span> cannot apply for any position as it is within '<span class='emerald'>" + suspendedMonths + "</span>' month(s) of leaving previous job. ";
                displayHtmlText = displayHtmlText + "Candidate left previous job on '<span class='emerald'>" + this.$filter('fourdotfiveDateFormat')(releaseDate) + "</span>' from the role '<span class='emerald'>" + releasedJobDetails.role + "</span>' ";
                displayHtmlText = displayHtmlText + "with Requisition Number '<span class='emerald'>" + releasedJobDetails.requisitionNumber + "</span>'.";
            }
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot add candidate</strong></div>",
                message: displayHtmlText,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
    };
    UploadResumesProcessedCandidatesController.prototype.toggleSelectAllCandidates = function () {
        var _this = this;
        if (this.selectedAllCandidatesFlag) {
            // if selectAllCandidates was already selected, remove all selections
            angular.forEach(this.candidatesList, function (val, key) {
                // if candidate was not already added successfully and was selected, de select it and remove it from associate list
                if (!val.candidateMatchedToJob && val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = false;
                    // if selected is removed, remove from candidates to associate list
                    _.remove(_this.candidatesToAssociateList, {
                        candidateId: val.candidateId
                    });
                }
            });
            this.selectedAllCandidatesFlag = false;
        }
        else {
            // if selectAllCandidates was not already selected
            angular.forEach(this.candidatesList, function (val, key) {
                // if candidate was not already added successfully and also not already selected, select it and add to associate list
                if (!val.candidateMatchedToJob && !val.selectedFlag && val.allowManualMatch) {
                    val.selectedFlag = true;
                    _this.candidatesToAssociateList.push(val);
                }
            });
            this.selectedAllCandidatesFlag = true;
        }
    };
    UploadResumesProcessedCandidatesController.prototype.jobCompare = function (candidate) {
        var actionObject = new JobMatchAction("Candidate Job Comparison", "CANDIDATE_JOB_COMPARE", true, null);
        candidate.id = candidate.candidateId;
        candidate.jobMatchJobId = this.jobId;
        this.jobMatchActionsService.performAction('uploadResumes', actionObject, candidate, function () {
        }, function () {
        });
    };
    UploadResumesProcessedCandidatesController.prototype.displayProcessedCandidates = function (activity) {
        var _this = this;
        $(".modal").addClass("upload-resumes-modal-medium");
        this.$timeout(function () {
            var displayCandidatesModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                component: 'uploadResumesTransactionCandidatesModal',
                windowTopClass: 'four-dot-five-modal-large',
                resolve: {
                    resumeProcessedObject: function () {
                        return _this.candidatesCount;
                    },
                    activity: function () {
                        return activity;
                    },
                    modalType: function () {
                        return "resumeProcessed";
                    },
                    activityMap: function () {
                        return _this.activityMap;
                    }
                }
            });
            displayCandidatesModal.result.then(function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }, function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }, 300);
    };
    UploadResumesProcessedCandidatesController.prototype._sendCandidateOutReachEmail = function (candidateIds, successCallback) {
        var _this = this;
        var candidateIdsWithCandidateType = [];
        candidateIds.forEach(function (candidateId) {
            candidateIdsWithCandidateType.push({ id: candidateId, candidateType: "OWN_CANDIDATES" });
        });
        var outreachObject = {
            candidates: candidateIdsWithCandidateType,
            userId: this.userId,
            companyId: this.companyId,
            clientOrBuId: null
        };
        this.candidateService.sendOutreachEmail(outreachObject, function (data) {
            _this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (successCallback) {
                successCallback();
            }
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    UploadResumesProcessedCandidatesController.prototype.completeResumeProcessed = function (type) {
        var _this = this;
        this.completeResumeSavingFlag = true;
        var isSendOutreachEmailChecked = (type === 'multipleResume') ? this.sendOutreachEmailMultipleResume : this.sendOutreachEmailSingleResume;
        if (isSendOutreachEmailChecked && this.ResumeProcessedCandidatesList.length > 0 && this.isOutreachEnabled) {
            this._sendCandidateOutReachEmail(this.ResumeProcessedCandidatesList, function () {
                _this.completeResumeSavingFlag = false;
                if (_this.completeCallback) {
                    _this.completeCallback();
                }
            });
        }
        else {
            this.completeResumeSavingFlag = false;
            if (this.completeCallback) {
                this.completeCallback();
            }
        }
    };
    UploadResumesProcessedCandidatesController.prototype.sendOutreachToAssociatedCandidates = function () {
        var _this = this;
        this.completeSendOutreachAssociatingCandidatesFlag = true;
        var candidateIds = [];
        this.candidatesList.map(function (candidate) {
            if (candidate.candidateId) {
                candidateIds.push(candidate.candidateId);
            }
        });
        if (this.sendOutreachEmailJobContext && candidateIds.length > 0 && this.isOutreachEnabled) {
            this._sendCandidateOutReachEmail(candidateIds, function () {
                _this.completeSendOutreachAssociatingCandidatesFlag = false;
                if (_this.completeCallback) {
                    _this.completeCallback();
                }
            });
        }
        else {
            this.completeSendOutreachAssociatingCandidatesFlag = false;
            if (this.completeCallback) {
                this.completeCallback();
            }
        }
    };
    return UploadResumesProcessedCandidatesController;
}());
// UploadResumesProcessedCandidatesController.$inject = ['$rootScope', '$uibModal', '$timeout', 'modalService'];
// UploadResumesProcessedCandidatesController.$inject = '[$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'jobMatchActionsService', 'alertsAndNotificationsService', 'resumeService', 'jobMatchService', 'candidateService', 'jobService', 'MESSAGECONSTANTS'];
UploadResumesProcessedCandidatesController.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'jobMatchActionsService', 'alertsAndNotificationsService', 'resumeService', 'jobMatchService', 'candidateService', 'jobService', 'notificationsService', 'MESSAGECONSTANTS'];
import * as TEMPLATE from 'raw-loader!./upload-resumes-processed-candidates.html';
export var UploadResumesProcessedCandidatesComponent = {
    selector: 'uploadResumesProcessedCandidates',
    component: {
        bindings: {
            candidatesCount: '<',
            jobId: '@',
            candidateId: '@',
            notificationId: '@',
            headingTitle: '@',
            cancelCallback: '&',
            candidateProcessedCallback: '&',
            completeCallback: '&'
        },
        template: TEMPLATE.default,
        controller: UploadResumesProcessedCandidatesController
    }
};
//# sourceMappingURL=upload-resumes-processed-candidates.component.js.map